import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[cityvalidation]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: CitiesDirective,
            multi: true,
        }
    ],
    standalone: false
})
export class CitiesDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors {
   return /^([A-Za-zÀ-ÿčęàâæéêèëïîôœûùç:()&.,?!''|<>-]+\s)*[A-Za-zÀ-ÿčęàâæéêèëïîôœûùç:()&.,?!''|<>-]*$/.test(control.value)
     ? null
     : { invalid : true };
 };
}
